import _ from "lodash"

export function handleOptsForFilter(data, key) {
  // Asegurarse de que data sea un array, incluso si es null o undefined
  const safeData = Array.isArray(data) ? data : []

  // Obtener los valores del campo 'key', asegurándonos de que no sean nulos o undefined
  const optionList = safeData.map((item) => item?.[key]).filter(Boolean)

  // Dividir cadenas por comas y eliminar espacios en blanco
  const optionListFlattened = optionList.flatMap((item) =>
    item.split(",").map((value) => value.trim())
  )

  // Eliminar duplicados
  const uniqueOptions = Array.from(new Set(optionListFlattened))

  // Convertir a formato de opciones con label y value
  const options = uniqueOptions.map((option) => ({
    label: option,
    value: option,
  }))

  // Agregar la opción "All" al principio
  return [{ label: "All", value: "" }, ...options]
}

export const formatDate = (value) => {
  return new Date(value).toLocaleDateString("en-US", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  })
}

export const formatLength = (minutes) => {
  if (minutes < 60) {
    return `${minutes} minute${minutes > 1 ? "s" : ""}`
  } else {
    const hours = Math.floor(minutes / 60)
    const remainingMinutes = minutes % 60
    return `${hours} hour${hours > 1 ? "s" : ""}${
      remainingMinutes > 0
        ? ` and ${remainingMinutes} minute${remainingMinutes > 1 ? "s" : ""}`
        : ""
    }`
  }
}
